export const getByIds = <T extends { id: string | number }>(items: T[], ids: (string | number)[]): T[] => {
    const foundItems = items.filter((item) => ids.includes(item.id));

    if (foundItems.length !== ids.length) {
        throw new Error(`Some ids are missing.`);
    }

    return foundItems;
};
